export const env = {
	APP_NAME: import.meta.env.VITE_APP_NAME ?? "Relevoo",
	SERVER_URL: import.meta.env.VITE_SERVER_URL ?? "http://localhost:8090",
	ADMIN_URL: import.meta.env.VITE_ADMIN_URL ?? "http://localhost:3000",
	SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN ?? "",
	POSTHOG_PROJECT_TOKEN: import.meta.env.VITE_POSTHOG_PROJECT_TOKEN ?? "",
	POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST ?? "",
	DEV: import.meta.env.DEV,
};
